module.exports = __webpack_public_path__ + "Flag-728.11d8854e224588a42d03630fd167ec62.svg";